<template>
  <div>
    <keep-alive>
      <template v-if="!isPurchaseSonOrder">
        <!--0:待确认 1500:发车待验车 2500:履约中-->
        <launchReturn
          v-if="state === 0 || state === 1500 || state === 2500"
        ></launchReturn>
        <returnInfo v-else></returnInfo>
      </template>
      <exitCarInfo v-else />
    </keep-alive>
  </div>
</template>

<script>
import launchReturn from './returnContent/launchReturn.vue'
import returnInfo from './returnContent/returnInfo.vue'
import exitCarInfo from './exitCarInfo.vue'

export default {
  components: {
    returnInfo,
    launchReturn,
    exitCarInfo,
  },
  data() {
    return {
      state: null,
      isPurchaseSonOrder: false, // 是否为采购子订单
    }
  },
  created() {
    this.state = Number(this.$route.query.state)
    this.isPurchaseSonOrder = this.$route.query.orderType === 'purchaseSonOrder'
  },
}
</script>
